/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MarketingScenarioProcess } from './marketingScenarioProcess';
import { TransactionalScenarioProcess } from './transactionalScenarioProcess';

export interface ScenarioVersionLiteDTO { 
    id?: string;
    scenarioId?: string;
    version?: number;
    process?: MarketingScenarioProcess | TransactionalScenarioProcess;
    status?: ScenarioVersionLiteDTO.StatusEnum;
    createdAt?: Date;
    updatedAt?: Date;
    updateAt?: Date;
}
export namespace ScenarioVersionLiteDTO {
    export type StatusEnum = 'DRAFT' | 'PUBLISH' | 'STOPPED';
    export const StatusEnum = {
        DRAFT: 'DRAFT' as StatusEnum,
        PUBLISH: 'PUBLISH' as StatusEnum,
        STOPPED: 'STOPPED' as StatusEnum
    };
}